module.exports = __webpack_public_path__ + "img/main_right2.148611f2.png";